import React from 'react';
import { Sparkles, BookOpenCheck, ExternalLink, Code2 } from 'lucide-react';
import { getEffectiveApiBaseUrl } from '../../../../shared/api/client.js';

export const ApiDocsBanner: React.FC = () => {
  const apiBase = getEffectiveApiBaseUrl();
  const swaggerUrl = `${apiBase}/api/docs/swagger`;
  const openApiUrl = `${apiBase}/api/docs/openapi.json`;

  return (
    <div className="bg-gradient-to-r from-indigo-900 via-indigo-950 to-slate-900 p-5 sm:p-6 rounded-2xl shadow-lg border border-indigo-800 text-white flex flex-col md:flex-row md:items-center justify-between gap-4">
      <div className="space-y-1.5 max-w-xl">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-amber-400" />
          <span className="text-xs font-bold uppercase tracking-wider text-amber-300">
            Hono OpenAPI 3.0 & Swagger UI Integrated
          </span>
        </div>
        <h3 className="text-base sm:text-lg font-bold text-white">
          Dokumentasi Interaktif & Spesifikasi Resmi API
        </h3>
        <p className="text-xs text-indigo-200 leading-relaxed">
          Eksplorasi dan uji coba endpoint RESTful API UIBN secara langsung menggunakan antarmuka Swagger UI interaktif atau unduh skema JSON OpenAPI 3.0 standar.
        </p>
      </div>

      <div className="flex flex-wrap items-center gap-2.5 shrink-0">
        <a
          href={swaggerUrl}
          target="_blank"
          rel="noreferrer"
          className="px-4 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-xs flex items-center gap-2 shadow-sm transition border border-indigo-400/30 cursor-pointer"
        >
          <BookOpenCheck className="w-4 h-4" />
          <span>Buka Swagger UI</span>
          <ExternalLink className="w-3.5 h-3.5 opacity-80" />
        </a>

        <a
          href={openApiUrl}
          target="_blank"
          rel="noreferrer"
          className="px-4 py-2.5 rounded-xl bg-slate-800 hover:bg-slate-700 text-indigo-200 font-bold text-xs flex items-center gap-2 transition border border-slate-700 cursor-pointer"
        >
          <Code2 className="w-4 h-4 text-amber-400" />
          <span>OpenAPI 3.0 Spec</span>
          <ExternalLink className="w-3.5 h-3.5 opacity-80" />
        </a>
      </div>
    </div>
  );
};

